import { DeliveryFormFilter as LA_DeliveryFormFilter } from 'app/shared/prothesis-api-filters/delivery-form-filter';
import { DeliveryFormFilter as CA_DeliveryFormFilter } from 'app/shared/prothesis-customer-api-filters/delivery-form-filter';
import { SpreadsheetExportType } from '../enums/spreadsheet-export-type.enum';

export class SpreadsheetExportTypeHelper {
  public static translateEnum(
    enumValue: SpreadsheetExportType,
    filter: LA_DeliveryFormFilter | CA_DeliveryFormFilter | null,
  ): string | undefined {
    if (enumValue === SpreadsheetExportType.DeliveryForm) {
      if (filter) {
        if (filter.invoicedFlag) {
          return 'Bons facturés';
        }
        if (filter.proFormaFlag) {
          return 'Bons sur pro forma';
        }
      }

      return 'Bons de livraison';
    } else if (enumValue === SpreadsheetExportType.DeliveryFormItem) {
      if (filter) {
        if (filter.invoicedFlag) {
          return 'Articles des bons facturés';
        }
        if (filter.proFormaFlag) {
          return 'Articles des bons sur pro forma';
        }
      }

      return 'Articles des bons de livraison';
    } else if (enumValue === SpreadsheetExportType.DeliveryFormItemLaboratoryTask) {
      if (filter) {
        if (filter.invoicedFlag) {
          return 'Tâches des bons facturés';
        }
        if (filter.proFormaFlag) {
          return 'Tâches des bons sur pro forma';
        }
      }

      return 'Tâches des bons de livraison';
    } else if (enumValue === SpreadsheetExportType.DeliveryFormItemRawMaterial) {
      if (filter) {
        if (filter.invoicedFlag) {
          return 'Matières des bons facturés';
        }
        if (filter.proFormaFlag) {
          return 'Matières des bons sur pro forma';
        }
      }

      return 'Matières des bons de livraison';
    } else if (enumValue === SpreadsheetExportType.FittingForm) {
      return "Bons d'essayage";
    } else if (enumValue === SpreadsheetExportType.FittingFormItem) {
      return "Articles des bons d'essayage";
    } else if (enumValue === SpreadsheetExportType.FittingFormItemLaboratoryTask) {
      return "Tâches des bons d'essayage";
    } else if (enumValue === SpreadsheetExportType.FittingFormItemRawMaterial) {
      return "Matières des bons d'essayage";
    } else if (enumValue === SpreadsheetExportType.Quote) {
      return 'Devis';
    } else if (enumValue === SpreadsheetExportType.QuoteItem) {
      return 'Articles des devis';
    } else if (enumValue === SpreadsheetExportType.QuoteItemLaboratoryTask) {
      return 'Tâches des devis';
    } else if (enumValue === SpreadsheetExportType.WorkForm) {
      return 'Bons de travail';
    } else if (enumValue === SpreadsheetExportType.WorkFormItem) {
      return 'Articles des bons de travail';
    } else if (enumValue === SpreadsheetExportType.WorkFormItemLaboratoryTask) {
      return 'Tâches des bons de travail';
    } else if (enumValue === SpreadsheetExportType.WorkFormItemRawMaterial) {
      return 'Matières des bons de travail';
    } else if (enumValue === SpreadsheetExportType.Customer) {
      return 'Clients';
    } else if (enumValue === SpreadsheetExportType.CustomerContact) {
      return 'Contacts des clients';
    } else if (enumValue === SpreadsheetExportType.CustomerUserCustomer) {
      return "Utilisateurs d'espaces clients";
    } else if (enumValue === SpreadsheetExportType.Manufacturer) {
      return 'Fabricants';
    } else if (enumValue === SpreadsheetExportType.ManufacturerContact) {
      return 'Contacts des fabricants';
    } else if (enumValue === SpreadsheetExportType.Item) {
      return 'Articles';
    } else if (enumValue === SpreadsheetExportType.ItemLaboratoryTaskTemplate) {
      return 'Tâches programmées des articles';
    } else if (enumValue === SpreadsheetExportType.ItemRate) {
      return 'Tarifs des articles';
    } else if (enumValue === SpreadsheetExportType.ItemRateComparison) {
      return 'Comparatif tarifs';
    } else if (enumValue === SpreadsheetExportType.ItemRawMaterial) {
      return 'Matières des articles';
    } else if (enumValue === SpreadsheetExportType.RawMaterial) {
      return 'Matières';
    } else if (enumValue === SpreadsheetExportType.RawMaterialBatchNumber) {
      return 'Numéros de lot des matières';
    } else if (enumValue === SpreadsheetExportType.Shade) {
      return 'Teintes';
    } else if (enumValue === SpreadsheetExportType.ShadeRawMaterial) {
      return 'Matières des teintes';
    } else if (enumValue === SpreadsheetExportType.ProForma) {
      return 'Factures pro forma';
    } else if (enumValue === SpreadsheetExportType.ProFormaDeliveryForm) {
      return 'Bons sur pro forma';
    } else if (enumValue === SpreadsheetExportType.ProFormaDeliveryFormItem) {
      return 'Articles des bons sur pro forma';
    } else if (enumValue === SpreadsheetExportType.ProFormaDeliveryFormItemRawMaterial) {
      return 'Matières des bons sur pro forma';
    } else if (enumValue === SpreadsheetExportType.Invoice) {
      return 'Factures définitives';
    } else if (enumValue === SpreadsheetExportType.InvoiceDeliveryForm) {
      return 'Bons facturés';
    } else if (enumValue === SpreadsheetExportType.InvoiceDeliveryFormItem) {
      return 'Articles des bons facturés';
    } else if (enumValue === SpreadsheetExportType.InvoiceDeliveryFormItemRawMaterial) {
      return 'Matières des bons facturés';
    } else if (enumValue === SpreadsheetExportType.InvoiceFreeLine) {
      return "Lignes d'annulations d'avoirs";
    } else if (enumValue === SpreadsheetExportType.InvoiceUnpaidReminder) {
      return 'Factures à relancer';
    } else if (enumValue === SpreadsheetExportType.InvoiceUnpaidReminderMailing) {
      return 'Publipostage des relances';
    } else if (enumValue === SpreadsheetExportType.Credit) {
      return "Factures d'avoir";
    } else if (enumValue === SpreadsheetExportType.CreditDeliveryForm) {
      return 'Bons sur avoir intégral';
    } else if (enumValue === SpreadsheetExportType.CreditDeliveryFormItem) {
      return 'Articles des bons sur avoir intégral';
    } else if (enumValue === SpreadsheetExportType.CreditDeliveryFormItemRawMaterial) {
      return 'Matières des bons sur avoir intégral';
    } else if (enumValue === SpreadsheetExportType.CreditFreeLine) {
      return "Lignes d'avoirs libres";
    } else if (enumValue === SpreadsheetExportType.ItemFamily) {
      return 'Familles';
    } else if (enumValue === SpreadsheetExportType.RawMaterialCategory) {
      return 'Catégories';
    } else if (enumValue === SpreadsheetExportType.ShadeGuide) {
      return 'Teintiers';
    } else if (enumValue === SpreadsheetExportType.Rate) {
      return 'Tarifs';
    } else if (enumValue === SpreadsheetExportType.MiscellaneousOperation) {
      return 'Opérations diverses';
    } else if (enumValue === SpreadsheetExportType.Patient) {
      return 'Dossiers patients';
    } else if (enumValue === SpreadsheetExportType.Payment) {
      return 'Règlements';
    } else if (enumValue === SpreadsheetExportType.FiscalYear) {
      return 'Exercices comptables';
    } else if (enumValue === SpreadsheetExportType.LaboratoryInformation) {
      return 'Paramètres du laboratoire';
    } else if (enumValue === SpreadsheetExportType.LaboratoryInformationBank) {
      return 'Banques du laboratoire';
    } else if (enumValue === SpreadsheetExportType.LaboratoryInformationContact) {
      return 'Contacts du laboratoire';
    } else if (enumValue === SpreadsheetExportType.LaboratoryInformationDeliveryRoute) {
      return 'Tournées du laboratoire';
    } else if (enumValue === SpreadsheetExportType.LaboratoryRole) {
      return 'Rôles';
    } else if (enumValue === SpreadsheetExportType.ApiCredential) {
      return "Clés d'API";
    } else if (enumValue === SpreadsheetExportType.LaboratoryUserCustomerSetting) {
      return 'Paramètres des espaces clients';
    } else if (enumValue === SpreadsheetExportType.LaboratoryTax) {
      return 'Paramètre des taxes';
    } else if (enumValue === SpreadsheetExportType.LaboratoryTaskNameSuggestion) {
      return 'Désignation des tâches du laboratoire';
    } else if (enumValue === SpreadsheetExportType.All) {
      return 'Intégralité des données du laboratoire';
    } else if (enumValue === SpreadsheetExportType.SimpleDetailedDeliveryForm) {
      if (filter) {
        if (filter.invoicedFlag) {
          return 'bons facturés';
        }
        if (filter.proFormaFlag) {
          return 'bons sur pro forma';
        }
      }

      return 'bons de livraison';
    } else if (enumValue === SpreadsheetExportType.SimpleDetailedFittingForm) {
      return "bons d'essayage";
    } else if (enumValue === SpreadsheetExportType.SimpleDetailedQuote) {
      return 'devis';
    } else if (enumValue === SpreadsheetExportType.SimpleDetailedWorkForm) {
      return 'bons de travail';
    } else if (enumValue === SpreadsheetExportType.SimpleDeliveryForm) {
      if (filter) {
        if (filter.invoicedFlag) {
          return 'bons facturés';
        }
        if (filter.proFormaFlag) {
          return 'bons sur pro forma';
        }
      }

      return 'bons de livraison';
    } else if (enumValue === SpreadsheetExportType.SimpleFittingForm) {
      return "bons d'essayage";
    } else if (enumValue === SpreadsheetExportType.SimpleQuote) {
      return 'devis';
    } else if (enumValue === SpreadsheetExportType.SimpleWorkForm) {
      return 'bons de travail';
    } else if (enumValue === SpreadsheetExportType.Sector) {
      return 'Secteurs';
    } else if (enumValue === SpreadsheetExportType.LaboratoryResource) {
      return 'Ressources';
    } else if (enumValue === SpreadsheetExportType.LaboratoryResourceContact) {
      return 'Contacts des ressources';
    } else if (enumValue === SpreadsheetExportType.UserLaboratory) {
      return 'Utilisateurs du laboratoire';
    } else if (enumValue === SpreadsheetExportType.PurchaseInvoice) {
      return "Factures d'achat";
    } else if (enumValue === SpreadsheetExportType.PurchaseCredit) {
      return "Avoirs d'achat";
    }

    return undefined;
  }
}
